import React, { useEffect, useRef } from 'react';

const MyMapComponent = () => {
  const mapRef = useRef(null); // Ссылка на div карты
  const mapInstanceRef = useRef(null); // Ссылка на экземпляр ymaps.Map

  useEffect(() => {
    const loadYmapsScript = () => {
      const script = document.createElement('script');
      script.src = `https://api-maps.yandex.ru/2.1/?lang=ru_RU&apikey=${process.env.REACT_APP_YANDEX_MAPS_API_KEY}`;
      script.async = true;
      script.onload = () => {
        // eslint-disable-next-line no-undef
        ymaps.ready(() => {
          // Проверяем, была ли карта уже создана
          if (!mapInstanceRef.current) {
            try {
                // eslint-disable-next-line no-undef
              const myMap = new ymaps.Map(mapRef.current, { // Используем mapRef.current для div
                center: [45.35043847407391, 36.47285769463324],
                zoom: 19
              });
                // eslint-disable-next-line no-undef
              const myPlacemark = new ymaps.Placemark([45.35043847407391, 36.47285769463324]);
              myMap.geoObjects.add(myPlacemark);

              mapInstanceRef.current = myMap; // Сохраняем экземпляр карты
            } catch (error) {
              console.error("Ошибка при инициализации карты:", error);
            }
          }
        });
      };
      script.onerror = () => {
        console.error("Ошибка при загрузке API Яндекс.Карт");
      };
      document.head.appendChild(script);
    };

    if (typeof ymaps === 'undefined') {
      loadYmapsScript();
    } else {
        // eslint-disable-next-line no-undef
      ymaps.ready(() => {
        // Проверяем, была ли карта уже создана
        if (!mapInstanceRef.current) {
            // eslint-disable-next-line no-undef
          const myMap = new ymaps.Map(mapRef.current, { // Используем mapRef.current для div
            center: [45.35043847407391, 36.47285769463324],
            zoom: 19
          });
            // eslint-disable-next-line no-undef
          const myPlacemark = new ymaps.Placemark([45.35043847407391, 36.47285769463324]);
          myMap.geoObjects.add(myPlacemark);

          mapInstanceRef.current = myMap; // Сохраняем экземпляр карты
        }
      });
    }

    // Функция уничтожения карты при размонтировании компонента
    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.destroy(); // Уничтожаем карту
        mapInstanceRef.current = null; // Очищаем ссылку
      }
    };
  }, []);

  return <div ref={mapRef} className="map" style={{ width: '100%', height: '500px' }}></div>; // Привязываем ref к div
};

export default MyMapComponent;